var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAuditTrail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8DDAEF4A-C429-499C-A9D6-0CC08A0692DE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entity-Details-+-Data-Tracker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxPro-DT-1.0",
    transform: "translate(-30.000000, -370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audit-Trail-Section-Button",
    transform: "translate(24.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataTracker",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.74,18.33 C21.15,16.6 22,14.4 22,12 C22,6.48 17.52,2 12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C14.4,22 16.6,21.15 18.33,19.74 C18.6,19.52 18.86,19.28 19.11,19.03 C19.14,19 19.16,18.97 19.18,18.95 C19.38,18.75 19.57,18.54 19.74,18.33 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,13.85 19.37,15.54 18.31,16.9 L16.88,15.47 C17.57,14.49 17.98,13.3 17.98,12.01 C17.98,8.7 15.29,6.01 11.98,6.01 C8.67,6.01 5.98,8.7 5.98,12.01 C5.98,15.32 8.67,18.01 11.98,18.01 C13.28,18.01 14.49,17.59 15.47,16.88 L16.89,18.3 C15.54,19.37 13.85,20 12,20 Z M13.92,12.51 C14.09,11.85 13.94,11.13 13.43,10.61 L13.41,10.59 C12.64,9.82 11.41,9.81 10.63,10.55 C10.62,10.56 10.6,10.57 10.58,10.59 C9.8,11.37 9.8,12.64 10.58,13.42 L10.6,13.44 C11.12,13.95 11.85,14.11 12.51,13.93 L14.02,15.44 C13.42,15.8 12.73,16.02 11.98,16.02 C9.77,16.02 7.98,14.23 7.98,12.02 C7.98,9.81 9.77,8.02 11.98,8.02 C14.19,8.02 15.98,9.81 15.98,12.02 C15.98,12.75 15.77,13.43 15.42,14.02 L13.92,12.51 Z",
    id: "Shape",
    fill: "#232A5C"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuditTrail);
export default __webpack_public_path__ + "static/media/Icon_AuditTrail.8a31a7da.svg";
export { ForwardRef as ReactComponent };